(function () {
  function syncHeroHeight(root) {
    var offset = 0;
    var topBar = document.querySelector('.repolished-top-bar');
    var header = document.querySelector('.repolished-header');

    if (topBar) {
      offset += topBar.getBoundingClientRect().height;
    }

    if (header) {
      offset += header.getBoundingClientRect().height;
    }

    if (!offset) {
      var group = document.querySelector('[id^="shopify-section-group-header"]');
      if (group) {
        offset = group.getBoundingClientRect().height;
      }
    }

    if (offset > 0) {
      root.style.setProperty('--rr-header-offset', Math.ceil(offset) + 'px');
    }
  }

  function initHero(root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var speed = parseInt(root.getAttribute('data-autoplay'), 10) || 6500;
    var autoplayEnabled = root.getAttribute('data-autoplay-enabled') !== 'false';
    var current = 0;
    var timer;

    if (!slides.length) return;

    syncHeroHeight(root);

    function goTo(index) {
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = null;
      if (!autoplayEnabled || slides.length <= 1) return;
      timer = setInterval(next, speed);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        resetTimer();
      });
    });

    root.addEventListener('mouseenter', function () {
      if (!autoplayEnabled || !timer) return;
      clearInterval(timer);
      timer = null;
    });

    root.addEventListener('mouseleave', function () {
      if (autoplayEnabled) resetTimer();
    });

    goTo(0);
    resetTimer();
  }

  function boot() {
    document.querySelectorAll('[data-repolished-hero]').forEach(initHero);
  }

  function onResize() {
    document.querySelectorAll('[data-repolished-hero]').forEach(syncHeroHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', onResize);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-repolished-hero]');
    if (root) initHero(root);
  });
})();
